<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
      <track-performance-component :accountId="accountId" :tailwind=true></track-performance-component>
  </div>
</template>

<script>

export default {
  name: "AccountTrackPerformanceComponent",

  props: {
    accountId: {
      type: Number,
      required: false,
    },
  },
}
</script>